<div class="footer-container">
    <div class="footer-logo">
        <img src="/assets/images/footer-logo.png" height="40px" alt="">
    </div>
    <div class="links">
        <a target="_blank" href="https://concoursefederal.com/">ABOUT CONCOURSE FEDERAL</a>
        <a target="_blank" href="https://concoursefederal.com/contact">CONTACT US</a>
    </div>
    <div class="copyright">Copyright &copy; {{currentYear}}</div>
</div>